import React from 'react';

import { useTranslation } from 'react-i18next';

import { Currency, formatCurrencyWithSymbolOnly, formatCurrencyCodeAndSymbol } from 'domains-billing-currency';

import { M, H4 } from 'components/typography';

import styles from './styles.scss';

export function InvoiceTotalWithBreakdown({
  currency,
  locale,
  taxInclusive,
  taxLabel,
  taxTotalLabel,
  invoiceSubtotal,
  invoiceTax,
  adminFeeTotal,
  adminFeeTaxTotal,
  invoiceTotal,
}: {
  currency: Currency;
  locale: string;
  taxInclusive: boolean;
  taxLabel: string;
  taxTotalLabel: string;
  invoiceSubtotal: number;
  invoiceTax: number;
  adminFeeTotal: number;
  adminFeeTaxTotal: number;
  invoiceTotal: number;
}) {
  const { t } = useTranslation();

  return (
    <div className={styles.invoiceTotalContainer}>
      <div className={styles.invoiceTotalGrid}>
        {taxInclusive && (
          <>
            <M className={`${styles.item} ${styles.muted}`}>
              {taxLabel} {t('abp.invoice.details.tax.included')}
            </M>
            <M className={`${styles.item} ${styles.muted}`}>
              {formatCurrencyWithSymbolOnly(currency, invoiceTax, locale)}
            </M>
          </>
        )}
        <M className={`${styles.item} ${styles.subtotal}`}>
          {t('abp.invoice.details.subtotal')}
        </M>
        <M className={`${styles.item} ${styles.subtotal}`}>
          {formatCurrencyWithSymbolOnly(currency, invoiceSubtotal, locale)}
        </M>
        <hr className={styles.divider} />
        <M className={styles.item}>{t('abp.invoice.details.adminFee')}</M>
        <M className={styles.item}>{formatCurrencyWithSymbolOnly(currency, adminFeeTotal, locale)}</M>
        <M className={styles.item}>{t('abp.invoice.details.adminFeeTax')}</M>
        <M className={styles.item}>{formatCurrencyWithSymbolOnly(currency, adminFeeTaxTotal, locale)}</M>
        {!taxInclusive && (
          <>
            <M className={styles.item}>{taxLabel}</M>
            <M className={styles.item}>{formatCurrencyWithSymbolOnly(currency, invoiceTax, locale)}</M>
          </>
        )}
        <hr className={styles.divider} />
        <H4 className={styles.item}>{taxTotalLabel}</H4>
        <div className={styles.invoiceTotal}>
          <H4 className={styles.item}>
            {formatCurrencyCodeAndSymbol(currency, invoiceTotal, locale)}
          </H4>
        </div>
      </div>
    </div>
  );
}
